export enum ErrorCodes {
  // Phone Number
  PhoneNumberNotMatching = 'phoneNumberNotMatching',
  NonUSPhone = 'nonUSPhone',
  NumberParseError = 'numberParseError',
  PhoneNumberRequired = 'PHONE_NUMBER_REQUIRED',

  // Pin Code
  WrongCode = 'wrongCode',
  ExpiredCode = 'expiredCode',
  VerificationCodeNeeded = 'verificationCodeNeeded',
  AlreadyVerified = 'alreadyVerified',
  ExceededVerificationAttempts = 'exceededVerificationAttempts',

  // Payment
  RejectionErrorCode2 = 'rejectionErrorCode:2', // wrong card type or canceled ?
  RejectionErrorCode6 = 'rejectionErrorCode:6', // wrongCardType - credit-card
  RejectionErrorCode140 = 'rejectionErrorCode:140', // wrongCardType - pre-paid
  RejectionErrorCode145 = 'rejectionErrorCode:145', // invalid card number
  RejectionErrorCode160 = 'rejectionErrorCode:160', // Could not verify card by hold
  RejectionErrorCode165 = 'rejectionErrorCode:165', // invalid cvv

  // ?
  ExpiredLink = 'LinkExpiredErrorCode:EXPIRED_LINK',
  ExpiredLinkOnPurchaseComplete = 'LinkExpiredErrorCode:COMPLETED_PURCHASE',
  ResourceNotExists = 'RESOURCE_NOT_EXISTS',
  WrongStateOfPurchase = 'WrongStateOfPurchase',
  InputCustomerDetailsMismatch = 'inputCustomerDetailsMismatch',
  SsnRequired = 'ssnRequired',
  AgeRestriction = 'ageRestriction',
  AgeRestriction19 = 'ageRestriction19',
  LeftMaxAmountsBeforeTaxErrorCode = 'leftMaxAmountsBeforeTaxErrorCode',

  // Max amount errors (contains many errors card issues & risk issues & can be seen at https://sunbitteam.slack.com/archives/G01MCUML3RT/p1685256308025879)
  OnlineCancellationErrorCode = 'onlineCancellationErrorCode',
  OfacPendingError = 'ofacPendingError',
  OfacFinalError = 'ofacFinalError',
  DuplicateSSN = 'duplicateSSN',
  SsnVerificationFailedTooManyTimes = 'ssnVerificationFailedTooManyTimes',
  ConsumerAlert = 'consumerAlert',
  IllegalArgument = 'ILLEGAL_ARGUMENT',
  PurchaseFinanceAmount = 'purchaseFinanceAmount',
  NumberOfAllowedActiveLoansExceeded = 'numberOfAllowedActiveLoansExceeded',
  InvalidRoutingNumber = 'invalidRoutingNumber',
  SsnNotValid = 'ssnNotValid',
  FallbackError = 'fallbackError',
  CancellationErrorCode6 = 'CancellationErrorCode:6',

  RetailerAmountWaitingTimeExceeded = 'RetailerAmountWaitingTimeExceeded',
  PurchaseAmountAlreadySet = 'PurchaseAmountAlreadySet',

  // 10: Fraud Prevention
  CancellationErrorCode10 = 'CancellationErrorCode:10',
  CancellationErrorCode22 = 'CancellationErrorCode:22',
  CancellationErrorCode90 = 'CancellationErrorCode:90',
  CancellationErrorCode91 = 'CancellationErrorCode:91',
  CancellationErrorCode95 = 'CancellationErrorCode:95',
  CancellationErrorCode96 = 'CancellationErrorCode:96',
  CancellationErrorCode97 = 'CancellationErrorCode:97',
  CancellationErrorCode98 = 'CancellationErrorCode:98',
  // 99: Risk decline - Late payment
  CancellationErrorCode99 = 'CancellationErrorCode:99',
  CancellationErrorCode100 = 'CancellationErrorCode:100',
  // 101: Risk decline - Score out of range
  CancellationErrorCode101 = 'CancellationErrorCode:101',
  // 102: Risk decline - TU File was not found
  CancellationErrorCode102 = 'CancellationErrorCode:102',
  CancellationErrorCode104 = 'CancellationErrorCode:104',
  CancellationErrorCode107 = 'CancellationErrorCode:107',
  CancellationErrorCode108 = 'CancellationErrorCode:108',
  CancellationErrorCode113 = 'CancellationErrorCode:113',
  CancellationErrorCode114 = 'CancellationErrorCode:114',
  CancellationErrorCode115 = 'CancellationErrorCode:115',
  // 116: Risk decline - SSN verification
  CancellationErrorCode116 = 'CancellationErrorCode:116',
  CancellationErrorCode118 = 'CancellationErrorCode:118',
  // 120: Could not charge down payment due to technical issue
  CancellationErrorCode120 = 'CancellationErrorCode:120',
  // 121: Credit freeze
  CancellationErrorCode121 = 'CancellationErrorCode:121',
  CancellationErrorCode125 = 'CancellationErrorCode:125',
  CancellationErrorCode130 = 'CancellationErrorCode:130',
  CancellationErrorCode132 = 'CancellationErrorCode:132',
  CancellationErrorCode190 = 'CancellationErrorCode:190',
  CancellationErrorCode191 = 'CancellationErrorCode:191',
  CancellationErrorCode192 = 'CancellationErrorCode:192',
  CancellationErrorCode221 = 'CancellationErrorCode:221',
  // 223: Risk decline - Previous creditor debt
  CancellationErrorCode223 = 'CancellationErrorCode:223',
  // Reason: MAX_ATTEMPTS_EXCEEDED (updating card)
  CancellationErrorCode210 = 'CancellationErrorCode:210',
  // 230: Duplicate signature card
  CancellationErrorCode230 = 'CancellationErrorCode:230',
  CancellationErrorCode300 = 'CancellationErrorCode:300',
  //Manual verification exception - currently doesn't exist.
  ExtraVerificationRequired = 'extraVerificationRequired',

  //Prove flow exception
  CustomerVerificationFlowRequired = 'customerVerificationFlowRequired',

  //Mitek flow exception
  ExtraVerificationFlowRequired = 'extraVerificationFlowRequired',
  ExtraVerificationFailed = 'extraVerificationFailed',
  ErrorEmail = 'ErrorEmail',
  DuplicateEmailError = 'DUPLICATE_EMAIL',
  ResendVerificationEmailNotAllowed = 'ResendVerificationEmailNotAllowed',
  ResendEmailTechnicalError = 'resendEmailTechnicalError',

  // Charge Failed Status
  ChargeFailed = 'chargeFailed',

  // Purchase Amount Limit Error
  PurchaseAmountLimit = 'purchaseAmountLimit',

  // Link Creation Error
  LinkCreationError = 'linkCreationError',

  // Duplicate email - DOB relations
  AccountAlreadyExists = 'account_already_exists',
}
